module.exports = __webpack_public_path__ + "img/pracitseNAN.d1c80d4a.png";